module.exports = __webpack_public_path__ + "static/led-screen-a-f0eeb3e6aeb03d41320c0fd08be51b0d.jpg";